import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClockModeConfig, ClockModeState } from '../../../../atoms/v3/clockModeAtoms';
import { ClockDisplay } from './ClockDisplay';
import { ClockModeControls } from './ClockModeControls';
import { ConfigurableArea } from './ConfigurableArea';
import { ClockModeThemeProvider } from './ClockModeThemeProvider';
import { ComponentThemeProvider } from './ComponentThemeProvider';
import ClockIconSprite from './ClockIconSprite';
import "@ncdai/react-wheel-picker/style.css";

interface ClockModeLayoutProps {
  config: ClockModeConfig;
  currentTime: Date;
  onLongPress: () => void;
  onExit: () => void;
  state: ClockModeState;
  onStateUpdate: (updates: Partial<ClockModeState>) => void;
  onEnterConfigMode?: () => void;
}

/**
 * 时钟模式布局组件
 * 实现 3x3 网格布局，左上角 2x2 合并
 */
export const ClockModeLayout: React.FC<ClockModeLayoutProps> = ({
  config,
  currentTime,
  onLongPress,
  onExit,
  state,
  onStateUpdate,
  onEnterConfigMode,
}) => {
  const { t } = useTranslation(['v3/clock']);
  // const [showAllControls, setShowAllControls] = useState(false);

  return (
    <ClockModeThemeProvider>
      <ComponentThemeProvider>
        {/* 主时钟区域 - 左上角 2x2 合并 */}
        <div
          className="clock-mode-area clock-mode-main-clock h-full w-full flex flex-col items-center justify-center relative clock-mode-area-transition z-50"
          // onMouseEnter={() => setShowAllControls(true)}
          // onMouseLeave={() => setShowAllControls(false)}
          onTouchStart={(e) => {
            // 长按检测
            const timer = setTimeout(() => {
              onLongPress();
            }, 1000);

            const cleanup = () => {
              clearTimeout(timer);
              document.removeEventListener('touchend', cleanup);
              document.removeEventListener('touchmove', cleanup);
            };

            const handleTouchMove = (moveEvent: TouchEvent) => {
              // 检查触摸移动是否发生在WheelPicker相关元素内，如果是则不清理长按计时器
              const target = moveEvent.target as Element;
              if (target && (
                target.closest('[data-rwp-wrapper]') ||
                target.closest('[data-rwp]') ||
                target.closest('.wheel-picker-wrapper')
              )) {
                return;
              }
              cleanup();
            };

            document.addEventListener('touchend', cleanup);
            document.addEventListener('touchmove', handleTouchMove);
          }}
        >
          {/* 主时钟显示 */}
          <ClockDisplay currentTime={currentTime} />

          {/* 控制按钮 */}
          <ClockModeControls
            state={state}
            onStateUpdate={onStateUpdate}
            onExit={onExit}
            onEnterConfigMode={onEnterConfigMode}
            // showAllControls={showAllControls}
          />
        </div>

        {/* 区域 2 */}
        <div className="clock-mode-area clock-mode-area-2">
          <ConfigurableArea
            areaId="area2"
            config={config.area2}
            currentTime={currentTime}
          />
        </div>

        {/* 区域 3 */}
        <div className="clock-mode-area clock-mode-area-3">
          <ConfigurableArea
            areaId="area3"
            config={config.area3}
            currentTime={currentTime}
          />
        </div>

        {/* 区域 4 */}
        <div className="clock-mode-area clock-mode-area-4">
          <ConfigurableArea
            areaId="area4"
            config={config.area4}
            currentTime={currentTime}
          />
        </div>

        {/* 区域 5 */}
        <div className="clock-mode-area clock-mode-area-5">
          <ConfigurableArea
            areaId="area5"
            config={config.area5}
            currentTime={currentTime}
          />
        </div>

        {/* 区域 6 */}
        <div className="clock-mode-area clock-mode-area-6">
          <ConfigurableArea
            areaId="area6"
            config={config.area6}
            currentTime={currentTime}
          />
        </div>

        <ClockIconSprite />
      </ComponentThemeProvider>
    </ClockModeThemeProvider>
  );
};

export default ClockModeLayout;
